import { useTranslation } from "react-i18next";
import styled from "styled-components";

import type { ExerciseStatus } from "./UserCourseExercise";

export const ActiveTag = ({
  status,
  startWeek,
  endWeek,
}: {
  status: ExerciseStatus;
  startWeek: number;
  endWeek: number | null | undefined;
}) => {
  const { t } = useTranslation();

  let label: string;
  switch (status) {
    case "planned":
      label = t("usercourse.tag.starts_week", { week: startWeek });
      break;
    case "expired":
      label = t("usercourse.tag.expired", { week: endWeek });
      break;
    case "active":
      label = t("usercourse.tag.active");
      break;
    default:
      label = "";
  }

  return <Root $active={status === "active"}>{label}</Root>;
};

const Root = styled.div<{ $active: boolean }>`
  font-size: 14px;
  padding: 4px 8px 4px 8px;
  border-radius: 4px;
  background-color: ${props => (props.$active ? "#EFF9F3" : "#FCF9ED")};
`;
